import { useState, useEffect, useCallback } from 'react';
import usersData from '../components/auth/usersdata.json';

// Create a custom event for auth state changes
const authStateChanged = new Event('authStateChanged');

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        console.log('User data retrieved from localStorage:', parsedUser);
      } catch (error) {
        console.error('Error parsing stored user data:', error);
      }
    }
  }, []);

  const login = useCallback((email, password, userType) => {
    const foundUser = usersData.users.find(u => u.email === email && u.password === password);

    if (foundUser) {
      const userDataToStore = { ...foundUser, password: undefined, userType };
      localStorage.setItem('currentUser', JSON.stringify(userDataToStore));
      setUser(userDataToStore);
      setError(null);
      console.log('User logged in:', userDataToStore);
      // Dispatch the custom event
      window.dispatchEvent(authStateChanged);
      return true;
    } else {
      setError('Invalid email or password');
      console.log('Login failed: Invalid email or password');
      return false;
    }
  }, []);


  const logout = useCallback(() => {
    localStorage.removeItem('currentUser');
    setUser(null);
    setError(null);
    // Dispatch the custom event
    window.dispatchEvent(authStateChanged);
  }, []);

  const signup = useCallback((userData) => {
    const storedUsers = JSON.parse(localStorage.getItem('users') || '[]');
    if (storedUsers.some(u => u.email === userData.email)) {
      setError('Email already exists');
      console.log('Signup failed: Email already exists');
      return false;
    }
    storedUsers.push(userData);
    localStorage.setItem('users', JSON.stringify(storedUsers));
    console.log('New user signed up:', userData);
    return login(userData.email, userData.password);
  }, [login]);


  const canPostJob = useCallback(() => {
    return user;
  }, [user]);

  const canCreateEvent = useCallback(() => {
    return user;
  }, [user]);

  const canCreateCampaign = useCallback(() => {
    return user && user.userType === 'institute';
  }, [user]);
  return { user, error, login, signup, logout, canPostJob, canCreateEvent, canCreateCampaign };
};